<div
    class="delay a-fx a-fx-start-center a-fx-gap-8"
    adsptHeap="conversion-delay-switch"
    [heapData]="{ 'disable/enable': delay() }"
>
    <nz-switch [ngModel]="delay()" (ngModelChange)="setDelay($event)"></nz-switch>

    <span (click)="toggleDelay()">
        {{ 'monitor.conversion-delay' | translate }}
    </span>
</div>
